<!--
反馈
20220331
-->
<template>
  <van-popup
    v-model="showSubplateFeedback"
    position="bottom"
    class="subplate_bricktype_info"
  >
    <div class="subplate_box">

      <div class="bricktype_title">反馈留言</div>
      <div class="releasedtips">
        有心人！感谢你点开了这个窗口。
        <br><br>
        如果对「积木小站」有任何意见或者建议，请千万不要吝啬，务必要给我们留言反馈。
        <br><br>
        留言我们肯定都会看，该处理的处理，该咋地的咋地。
        <br><br>
        通常这是单向的，非必要的话，我们可能不会主动联系你。
      </div>



      <div class="feedback_form">
        <label class="form_item form_item_plane">
          <div class="form_label">反馈主题</div>
          <div class="form_item_con">
            <div class="form_select">
              <select name="feedback_type" class="form_input appearance_none" placeholder="请选择" v-model="feedback_type">
                <option :value="item.value"
                  v-for="(item, index) in option" :key="index"
                >{{item.text}}</option>
              </select>
            </div>
          </div>
        </label>
        <label class="form_item form_item_plane">
          <div class="form_label">内容</div>
          <div class="form_item_con">
            <textarea class="form_input" name="feedback_text" v-model="feedback_text" :placeholder="placeholder" maxlength="1000"></textarea>
          </div>
        </label>
        <label class="form_item form_item_plane">
          <div class="form_label">联系方式（选填）</div>
          <div class="form_item_con">
            <input class="form_input" name="feedback_contact" v-model="feedback_contact" placeholder="线上的联系方式都行"></div>
          </label>
          <label class="origi_info form_item form_item_plane" v-if="feedback_origi_title">
            <div class="form_label">原始信息（不可修改，仅供参考）</div>
            <div class="form_item_con">
              <div class="form_static">{{feedback_origi_title}}</div>
            </div>
          </label>
        </div>





    </div>

    <div class="bottombar">
      <div class="bottombar_box">
        <div class="bottombar_part half">
          <a class="btn_inner btn btn_outline btn_color_4 btn_cancel btn_round" @click="showSubplateFeedback=false">
            <span>关闭</span>
          </a>
        </div>
        <div class="bottombar_part">
          <a class="btn_inner btn btn_shadow btn_color_2 btn_sure btn_round" @click="send">
            <span>提交</span>
          </a>
        </div>
      </div>
    </div>

  </van-popup>
</template>

<script>

export default {
  name: 'Feedback',
  components: {},
  props: {

  },
  data () {
    return {
      showSubplateFeedback: false,


      option: [
        {
          value: "资料",
          text: "资料有错误",
          placeholder: "最好能提供到正确的资料。",
        },
        {
          value: "未收录",
          text: "积木没有收录",
          placeholder: "最好能提供具体的品牌与编号。",
        },
        {
          value: "功能建议",
          text: "功能建议",
          placeholder: "请尽量详细的描述你的想法。感谢支持！",
        },
        {
          value: "不良信息",
          text: "有不良信息",
          placeholder: "请描述……",
        },
        {
          value: "其他",
          text: "纯留言",
          placeholder: "请尽量详细的说明你遇到的问题。感谢支持！",
        },
      ],



      placeholder: '请尽量详细的说明你遇到的问题。感谢支持！',



      feedback_type: '资料',
      feedback_text: '',
      feedback_contact: '',
      feedback_origi_title: '',
      feedback_origi_url: '',

      sendType: 0,//0 未发 1 发送中

    }
  },
  computed: {

  },
  watch: {
    feedback_type: function(newValue, oldValue){
      const _this = this;
      _this.option.forEach(function(n){
        if( n.value == newValue ){
          _this.placeholder = n.placeholder;//切换占位符
          //console.log(_this.placeholder);
          //_this.$forceUpdate();
        }
      });
    },

  },
  created() {
    const _this = this;



  },
  mounted() {

  },
  destroyed() {},
  methods: {

    //关闭面板
    hideSubplateFeedback(hide=true, data){
      const _this = this;
      _this.showSubplateFeedback = !hide;
      if( _this.showSubplateFeedback ){
        if( data ){
          if( data.type ){
            _this.option.forEach(function(n){
              if( n.value == data.type ){
                _this.feedback_type = data.type;
              }
            });
          }
          if( data.title ){
            _this.feedback_origi_title = data.title;
          } else {
            _this.feedback_origi_title = document.title;
          }
          if( data.url ){
            _this.feedback_origi_url = data.url;
          } else {
            _this.feedback_origi_url = location.href;
          }
        }
        if( !_this.feedback_origi_title ){
          _this.feedback_origi_title = document.title;
        }
        if( !_this.feedback_origi_url ){
          _this.feedback_origi_url = location.href;
        }
      }

    },

    //提交
    send(){
      const _this = this;

      if( _this.sendType ){
        return false;
      }


      let tmpParams = {
        feedback_type: _this.feedback_type,
        feedback_text: _this.feedback_text,
        feedback_contact: _this.feedback_contact,
        feedback_origi_title: _this.feedback_origi_title,
        feedback_origi_url: _this.feedback_origi_url,
      };

      //console.log(tmpParams);
      //return false;

      if( !tmpParams.feedback_text ){
        _this.$toast.fail('请填写反馈内容~');
        return false;
      }

      _this.sendType = 1;

      
      _this.axios.post(_this.$store.state.api.common + 'feedback/send/', _this.qs.stringify(
        tmpParams
      )).then(function(res){
        _this.sendType = 0;
        if( res.status == 200 ){
          if( typeof res.data != "object" ){
            try{
              res.data = JSON.parse(res.data);
            } catch(error) {
              _this.$toast.fail('提交反馈数据失败：接口异常');
              console.error(error);
              return false;
            }
          }
          if( res.data.status == 1 ){

            _this.$dialog({
              closeOnPopstate: true,//页面回退时自动关闭
              title: '提交成功',
              message: '棒棒的！多谢添砖加瓦！',
              confirmButtonText: '确定',
            }).then(() => {
              _this.showSubplateFeedback = false;
            }).catch(() => {
              
            });

          }else{
            _this.$toast.fail(res.data.msg ? res.data.msg : '提交反馈数据失败：出现了一些问题');
          }
        }else{
          _this.$toast.fail('提交反馈失败：请求失败');  
        }
      }).catch(function (error) {
        _this.sendType = 0;
        _this.$toast.fail('提交反馈失败');
        console.error(error);
      });





    },



  }
}
</script>



<style lang="less">

@bluecolor: #4E66FF;


</style>


<style lang="less" scoped>
@bluecolor: #4E66FF;

.subplate_bricktype_info {
  top: 80px;
  border-radius: 20px 20px 0 0;
  .subplate_box {
    padding: 30px 30px 60px;
    
    position: relative;

    .bricktype_title {
      font-size: 20px;
      font-weight: bold;
      color: #858585;
      margin-bottom: 10px;
    }

    .releasedtips {
      border: 1px dotted #e8e8e8;
      padding: 10px;
      background-color: #f8f8f8;
    }





  }


  

}


.form_item {
  border-bottom: none;
  margin-bottom: 10px;
  .form_label {
    width: auto;
    position: initial;
  }
  .form_item_con {
    font-size: 0;
    padding-left: 0;
  }
  .form_input {
    border: 1px solid #e8e8e8;
    padding: 0 10px;
    border-radius: 10px;
    &:focus {
      border: 1px solid #999;
      box-shadow: 0 0 0 2px #999;
    }
  }
  textarea.form_input {
    padding: 10px;
  }
  .form_static {
    background-color: #f4f4f4;
    padding-left: 10px;
    padding-right: 10px;
  }
}






</style>


// WEBPACK FOOTER //
// src/components/Feedback.vue